import AuthenticatedRoute from "routes/AuthenticatedRoute";
import UnauthenticatedRoute from "routes/UnauthenticatedRoute";
import unauthenticatedRoutes from "./unauthenticated";
import sharedRoutes from "./shared";
import peopleTeamRoutes from "./peopleTeam";
import managerRoutes from "./manager";
import internalRoutes from "./internal";
import adminRoutes from "./admin";

const initialAuthenticatedRoutes = [
  ...sharedRoutes,
  ...peopleTeamRoutes,
  ...managerRoutes,
  ...internalRoutes,
  ...adminRoutes,
];

const authenticatedRoutes = initialAuthenticatedRoutes.map((route) => ({
  ...route,
  component: (
    <AuthenticatedRoute permission={route.permission} allowPersonalEmail={route.allowPersonalEmail}>
      {route.component}
    </AuthenticatedRoute>
  ),
}));

const unauthenticatedRoutesWrapped = unauthenticatedRoutes.map(
  (route) => ({
    ...route,
    component: <UnauthenticatedRoute>{route.component}</UnauthenticatedRoute>,
  }),
);

export default unauthenticatedRoutesWrapped.concat(authenticatedRoutes);
